import * as React from "react";
import { Button } from "@vidazoo/ui";
import { observer } from "mobx-react";
import { Player } from "@lottiefiles/react-lottie-player";
import { sessionStore } from "common/stores";
import animation from "common/assets/noAccess.json";
import * as theme from "./theme.scss";

export interface INoAccessScreenProps {
	title?: string;
	description?: string;
}

const NoAccessScreen: React.FC<INoAccessScreenProps> = observer(({
	title = "You don't have permissions for this system",
	description = "Your account is missing the required access. Please contact your administrator to request access."
}) => {
	const onSignOut = () => {
		if (sessionStore.logout) {
			sessionStore.logout();
		} else {
			window.location.reload();
		}
	};

	return (
		<div className={theme.container}>
			<div className={theme.card}>
				<div className={theme.animation}>
					<Player
						autoplay
						loop
						src={animation}
						style={{ width: "160px", height: "160px" }}
					/>
				</div>
				<h1 className={theme.title}>{title}</h1>
				<p className={theme.description}>{description}</p>
				<div className={theme.actions}>
					<Button medium iconName="icon-sign-out" className={theme.signOut} onClick={onSignOut}>
						Sign out
					</Button>
				</div>
			</div>
		</div>
	);
});

export default NoAccessScreen;
